export const uploaderRoutesNames = {
  EMPTY_URL: '',
  DROPBOX: 'request'
};
